import HomeIcon from '@mui/icons-material/Home';
import { ListItemButton, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import React from 'react';
import { Translate } from 'react-jhipster';
import { Link } from 'react-router-dom';
import PublicIcon from '@mui/icons-material/Public';
interface IMapRoutesMenu {
  drawerIsOpen: boolean;
}

export const MapRoutesMenu = ({ drawerIsOpen }: IMapRoutesMenu) => {
  const initialTheme = localStorage.getItem('USER_THEME') as 'light' | 'dark' | null;

  return (
    <Tooltip title={drawerIsOpen ? '' : <Translate contentKey="global.menu.map">Home</Translate>} placement="right">
      <ListItemButton
        component={Link}
        to={'/dashboards'}
        sx={{
          pl: { xs: '18px', md: '32px' },
          '&:hover': {
            color: initialTheme === 'light' ? '#000814' : '#ABADC6',
          },
        }}
      >
        <ListItemIcon>
          <PublicIcon />
        </ListItemIcon>
        <ListItemText
          primary={<Translate contentKey="global.menu.map">Map</Translate>}
          primaryTypographyProps={{
            fontSize: '14px',
          }}
          sx={{ opacity: open ? 1 : 0 }}
        />
      </ListItemButton>
    </Tooltip>
  );
};
